import React from 'react'
import { IconSVGType } from '../../../types/icons'

/**
 * @param {IconSVGType} props
 */
const FileBMPIcon = (props: IconSVGType) => {
  return (
    <svg
      className={props.className}
      fill='none'
      height={props.height}
      viewBox={props.viewBox || '0 0 24 24'}
      width={props.width}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill='#5D5D5D'
        fillRule='evenodd'
        d='M4.01 4c0-1.1.89-2 1.99-2h7.17c.53 0 1.04.21 1.41.59l4.83 4.83c.38.37.59.88.59 1.41V20c0 1.1-.9 2-2 2H5.99C4.89 22 4 21.1 4 20l.01-16ZM13 3.5V8c0 .55.45 1 1 1h4.5L13 3.5ZM7.371 17H5.16v-4.9h2.247c.637 0 1.085.14 1.386.434.182.182.301.441.301.798v.035c0 .546-.322.903-.777 1.092.525.175.91.504.91 1.148v.028c0 .784-.609 1.365-1.855 1.365Zm-.245-2.968c.322 0 .49-.126.49-.357v-.007c0-.238-.175-.364-.49-.364H6.63v.728h.497Zm.588 1.386v-.007c0-.224-.175-.378-.51-.378h-.575v.763h.574c.336 0 .511-.154.511-.378ZM11.138 17H9.66v-4.9h1.54l.889 1.624.896-1.624h1.533V17h-1.491v-2.38l-.938 1.61h-.021l-.931-1.61V17Zm5.486 0h-1.505v-4.9h1.869c1.211 0 2.037.56 2.037 1.729v.042c0 1.211-.91 1.771-2.023 1.771h-.378V17Zm0-3.668v1.169h.301c.357 0 .609-.189.609-.567v-.028c0-.385-.231-.574-.602-.574h-.308Z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default FileBMPIcon
